import React, { useEffect, useState } from "react";
import Switch from "react-bootstrap-switch";
import ControlFeedback from "./ControlFeedback";
import { SwitchControlProps } from "./Types";

const SwitchControl: React.FC<SwitchControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur, onValue, onText, offValue, offText }) => {

    const [controlOnText, setOnText] = useState(onText ?? "✔")
    const [controlOffText, setOffText] = useState(onText ?? "✘")

    function onControlChange(component: Switch, enabled: boolean | null) {
        if (enabled === true && onValue !== undefined)
            onChange(onValue);
        else if (enabled === false && offValue !== undefined)
            onChange(offValue);
        else
            onChange(enabled);

        if (onBlur)
            onBlur();
    }

    useEffect(() => {
        if (onText !== undefined)
            setOnText(onText)
        else
            setOnText("✔")

        if (offText !== undefined)
            setOffText(offText)
        else
            setOffText("✘")

    }, [onText, offText, onValue, offValue])

    let isValid = validationResults && validationResults.length > 0 ? false : true
    let controlValue = (value == true) ? true : false;

    if (value === onValue)
        controlValue = true
    else if (value === offValue)
        controlValue = false
    else if (value === onText)
        controlValue = true
    else if (value === offText)
        controlValue = false

    if (width === undefined)
        width = '100%';

    return (
        <div style={{ width: width }}>
            <Switch
                value={controlValue}
                disabled={disabled}
                onChange={onControlChange}
                onText={controlOnText}
                onColor="success"
                offText={controlOffText}
                offColor="danger"
            />
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default SwitchControl;
